const smootherstep = (edge) => edge * edge * edge * (edge * (edge * 6 - 15) + 10);
function taperEnds(geometry, { halfLength, nose, tail, hold }) {
  const position = geometry.attributes.position;
  if (!position) return geometry;
  for (let i = 0; i < position.count; i += 1) {
    const x = position.getX(i);
    const distance = Math.min(Math.abs(x) / halfLength, 1);
    if (distance <= hold) continue;
    const eased = smootherstep((distance - hold) / (1 - hold));
    const target = x > 0 ? nose : tail;
    position.setZ(i, position.getZ(i) * (1 - eased * (1 - target)));
  }
  position.needsUpdate = true;
  return geometry;
}
export {
  taperEnds
};
